import { motion } from "framer-motion";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { RevealLines, FadeUp, Overline } from "./Reveal";
import { Polaroid } from "./BrandDecor";
import { scrollToId } from "./scrollUtils";

const PORTRAIT =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_valorizza-stile/artifacts/ae5628am_WhatsApp%20Image%202026-08-18%20at%2010.34.04.webp";

export const MiPresento = () => {
  return (
    <section
      id="mi-presento"
      className="relative py-24 sm:py-36 overflow-hidden"
      data-testid="mi-presento-section"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-20 relative z-10">
        <div>
          <Overline className="mb-8">Chi Sono</Overline>
          <h2 className="font-display uppercase text-fuchsiabrand text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            <RevealLines lines={["Mi", "Presento"]} />
          </h2>
          <FadeUp delay={0.2} className="mt-6">
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone">
              Dal 2021 · Formazione ESR Italia
            </span>
          </FadeUp>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="relative mt-14 max-w-sm"
            data-testid="mipresento-portrait"
          >
            <Polaroid
              src={PORTRAIT}
              alt="Alina Cossali, consulente d'immagine"
              rotate={-3}
              clip
              className="w-full"
              imgClassName="w-full aspect-[4/5] object-cover object-center"
            />
          </motion.div>
        </div>

        <div className="lg:pt-16">
          <FadeUp>
            <p className="font-sans font-semibold text-xl sm:text-2xl lg:text-[1.7rem] leading-[1.5] text-espresso">
              Mi chiamo <span className="text-fuchsiabrand">Alina Cossali</span> e lavoro
              nella moda da quando ho 18 anni. Per me l'abbigliamento non è mai stato semplice
              apparire, ma <span className="text-fuchsiabrand">comunicare chi sono</span>: nel
              2021, dopo la formazione presso ESR Italia, ho fatto di questa convinzione la mia
              professione.
            </p>
          </FadeUp>
          <FadeUp delay={0.15}>
            <p className="mt-8 text-lg leading-relaxed text-stone max-w-xl">
              Credo che l'immagine personale sia uno <span className="text-espresso font-medium">strumento
              potente</span> per veicolare la nostra essenza e renderla visibile. Uno stile personale
              diventa <span className="text-espresso font-medium">memorabile</span> quando è autentico
              e coerente alla nostra persona, rafforzando autostima e self-confidence.
            </p>
          </FadeUp>
          <FadeUp delay={0.22}>
            <p className="mt-6 text-lg leading-relaxed text-stone max-w-xl">
              Ma il mio approccio resta concreto. Gli anni nei negozi mi hanno insegnato un
              <span className="text-espresso font-medium"> metodo pratico, veloce e applicabile
              ogni giorno</span>: una consulenza d'immagine <span className="text-espresso font-medium">accessibile
              e reale</span>, pensata per renderti del tutto autonoma nelle tue scelte quotidiane.
            </p>
          </FadeUp>
          <FadeUp delay={0.3}>
            <p className="mt-8 text-lg text-espresso">
              La mia firma?{" "}
              <span className="font-sans font-extrabold text-xl">
                Professionalità, creatività ed empatia!
              </span>
            </p>
          </FadeUp>
        </div>
      </div>

      {/* Bridge CTA — decision point after the intro */}
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-[1400px] mx-auto px-5 sm:px-8 relative z-10 mt-20 sm:mt-24 pt-10 border-t border-espresso/10 flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-10"
      >
        <button
          onClick={() => scrollToId("#percorsi")}
          data-testid="mipresento-cta-percorsi"
          className="group inline-flex items-center justify-center gap-3 bg-espresso text-crema px-8 py-4 sm:py-5 rounded-full font-mono text-xs sm:text-sm uppercase tracking-[0.18em] hover:bg-fuchsiabrand transition-colors duration-300"
        >
          Scopri i miei percorsi
          <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
        </button>
        <button
          onClick={() => scrollToId("#servizi")}
          data-testid="mipresento-cta-servizi"
          className="group inline-flex items-center gap-2 text-espresso font-medium hover:text-fuchsiabrand transition-colors duration-300"
        >
          Oppure vai direttamente ai servizi
          <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform duration-300" />
        </button>
      </motion.div>
    </section>
  );
};
